export const GET_ALL_UNITS_THERMOKING = "GET_ALL_UNITS_THERMOKING";

export const getAllUnitsThermoking = (data) => {
    return {
        type: GET_ALL_UNITS_THERMOKING,
        payload: data
    }
};